// Product page interactions for Athana's Cakery Shopify product template.

(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function refreshCartDrawerAndBubble() {
    const headerSectionId =
      document.querySelector('cart-items-component[data-section-id]')?.dataset.sectionId;

    fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not fetch cart.');
        return res.json();
      })
      .then(function (cart) {
        const count = cart.item_count || 0;

        const cartIcon = document.querySelector('cart-icon.header-actions__cart-icon');
        const bubble = document.querySelector('.cart-bubble');
        const bubbleText = document.querySelector('.cart-bubble__text');
        const bubbleCount = document.querySelector('[data-testid="cart-bubble"]');

        if (cartIcon) {
          cartIcon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
        }

        if (bubble) {
          bubble.classList.toggle('visually-hidden', count <= 0);
          bubble.classList.remove('hidden');
          bubble.removeAttribute('hidden');
        }

        if (bubbleText) {
          bubbleText.classList.remove('hidden');
          bubbleText.removeAttribute('hidden');
        }

        if (bubbleCount) {
          bubbleCount.textContent = count;
          bubbleCount.classList.remove('hidden');
        }

        if (!headerSectionId) return;

        return fetch(window.location.pathname + '?sections=' + headerSectionId)
          .then(function (res) {
            if (!res.ok) throw new Error('Could not fetch header section.');
            return res.json();
          })
          .then(function (sections) {
            const html = sections[headerSectionId];
            if (!html) return;

            const doc = new DOMParser().parseFromString(html, 'text/html');

            const newDrawerInner = doc.querySelector('.cart-drawer__inner');
            const currentDrawerInner = document.querySelector('.cart-drawer__inner');

            if (newDrawerInner && currentDrawerInner) {
              currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
            }

            const newDialog = doc.querySelector('.cart-drawer__dialog');
            const currentDialog = document.querySelector('.cart-drawer__dialog');

            if (newDialog && currentDialog) {
              currentDialog.className = newDialog.className;

              if (newDialog.getAttribute('aria-labelledby')) {
                currentDialog.setAttribute(
                  'aria-labelledby',
                  newDialog.getAttribute('aria-labelledby')
                );
              }
            }

            const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
            if (trigger) trigger.click();
          });
      })
      .catch(function (error) {
        console.warn('Cart drawer refresh failed:', error);
      });
  }

  function initCakeProduct(root) {
    if (!root || root.dataset.pdpInitialized === 'true') return;

    root.dataset.pdpInitialized = 'true';

    const mainImg = root.querySelector('[data-pdp-main-img]');
    const thumbs = root.querySelectorAll('[data-pdp-thumb]');

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const src = btn.getAttribute('data-src');

        if (!src || !mainImg) return;

        mainImg.setAttribute('src', src);

        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
      });
    });

    const qtyInput = root.querySelector('[data-pdp-qty-input]');
    const qtyMinus = root.querySelector('[data-pdp-qty-minus]');
    const qtyPlus = root.querySelector('[data-pdp-qty-plus]');

    const syncMinus = function () {
      if (!qtyInput || !qtyMinus) return;
      qtyMinus.disabled = (parseInt(qtyInput.value, 10) || 1) <= 1;
    };

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        syncMinus();
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        syncMinus();
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        const value = parseInt(qtyInput.value, 10);

        if (value < 1 || isNaN(value)) {
          qtyInput.value = 1;
        }

        syncMinus();
      });

      syncMinus();
    }

    const jsonEl = root.querySelector('[data-product-json]');
    const variantInput = root.querySelector('[data-pdp-variant-id]');
    const priceEl = root.querySelector('[data-pdp-price]');
    const addButton = root.querySelector('[name="add"]');
    const buyNowButton = root.querySelector('[data-pdp-buy-now]');
    const form = root.querySelector('form[action*="/cart/add"]');

    let product = null;

    if (jsonEl) {
      try {
        product = JSON.parse(jsonEl.textContent);
      } catch (error) {
        product = null;
      }
    }

    function selectedOptions() {
      const options = [];

      root.querySelectorAll('[data-option-position]').forEach(function (group) {
        const position = Number(group.getAttribute('data-option-position')) - 1;
        const checked = group.querySelector('input[type="radio"]:checked');

        if (checked) {
          options[position] = checked.value;
        }
      });

      return options;
    }

    function findSelectedVariant() {
      if (!product || !product.variants) return null;

      const options = selectedOptions();

      return product.variants.find(function (variant) {
        return variant.options.every(function (optionValue, index) {
          return optionValue === options[index];
        });
      });
    }

    function updateVariant() {
      const variant = findSelectedVariant();

      if (!variant) return;

      if (variantInput) {
        variantInput.value = variant.id;
      }

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (addButton) {
        addButton.disabled = !variant.available;

        const text = addButton.querySelector('.add-to-cart-text__content span span');

        if (text) {
          text.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
      }

      if (buyNowButton) {
        buyNowButton.disabled = !variant.available;
      }

      if (variant.featured_image && variant.featured_image.src && mainImg) {
        mainImg.setAttribute('src', variant.featured_image.src);

        thumbs.forEach(function (thumb) {
          const thumbSrc = thumb.getAttribute('data-src');

          if (
            thumbSrc &&
            thumbSrc.indexOf(variant.featured_image.src.split('?')[0]) !== -1
          ) {
            thumbs.forEach(function (t) {
              t.classList.remove('is-active');
              t.setAttribute('aria-selected', 'false');
            });

            thumb.classList.add('is-active');
            thumb.setAttribute('aria-selected', 'true');
          }
        });
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('[data-option-position] input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    // Theme ka default add-to-cart AJAX chalne do.
    // Uske baad cart count + drawer refresh/open karo.
    if (addButton) {
      addButton.addEventListener('click', function () {
        setTimeout(refreshCartDrawerAndBubble, 900);
      });
    }

    if (buyNowButton && form) {
      buyNowButton.addEventListener('click', function () {
        if (!variantInput || !variantInput.value) return;

        buyNowButton.disabled = true;

        const body = new FormData();
        body.append('id', variantInput.value);
        body.append('quantity', qtyInput ? qtyInput.value : '1');

        fetch('/cart/add.js', {
          method: 'POST',
          body: body,
          headers: {
            Accept: 'application/json'
          }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Could not add product to cart.');
            window.location.href = '/checkout';
          })
          .catch(function () {
            buyNowButton.disabled = false;
            form.submit();
          });
      });
    }
  }

  function initAllCakeProducts() {
    document.querySelectorAll('[data-pdp]').forEach(initCakeProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCakeProducts);
  } else {
    initAllCakeProducts();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      event.target.querySelectorAll('[data-pdp]').forEach(initCakeProduct);
    }
  });
})();